import api_fetch from "../api.js"
import adapter from "webrtc-adapter"

let debug = false;

var WebRtcStreamer = (function() {

/**
 * Interface with WebRTC-streamer API
 * @constructor
 * @param {string} videoElement - id of the video element tag
 * @param {string} srvurl -  url of webrtc-streamer (default is current location)
*/
var WebRtcStreamer = function WebRtcStreamer (videoElement, srvurl) {
	if (typeof videoElement === "string") {
		this.videoElement = document.getElementById(videoElement);
	} else {
		this.videoElement = videoElement;
	}
	this.srvurl           = srvurl || location.protocol+"//"+window.location.hostname+":"+window.location.port;
	this.pc               = null;

	this.pcOptions        = { "optional": [{"DtlsSrtpKeyAgreement": true} ] };

	this.mediaConstraints = { offerToReceiveAudio: true, offerToReceiveVideo: true };

	this.iceServers = null;
	this.earlyCandidates = [];
}

/**
 * Connect a WebRTC Stream to videoElement
 * @param {string} videourl - id of WebRTC video stream
 * @param {string} audiourl - id of WebRTC audio stream
 * @param {string} options -  options of WebRTC call
 * @param {string} stream  -  local stream to send
*/
WebRtcStreamer.prototype.connect = function(videourl, audiourl, options, localstream) {
	// // this.webRtcServer.connect(this.props.camId , undefined, options);
	this.disconnect();

	// getIceServers is not already received
	if (!this.iceServers) {
		if (debug) console.log("Get IceServers");
		var bind = this;
		api_fetch(this.srvurl + "/api/getIceServers")
			.then(response => {
				if (!response.ok){
					throw new Error("response not ok {response.status} {response.statusText}" )
				}
				return response.json();
				}	
			)
			.then(data => {
				bind.onReceiveGetIceServers.call(bind,data, videourl, audiourl, options, localstream)
			})
			.catch(error => bind.onError("getIceServers" + error));
	} else {
		this.onReceiveGetIceServers(this.iceServers, videourl, audiourl, options, localstream);
	}
}

/**
 * Disconnect a WebRTC Stream and clear videoElement source
*/
WebRtcStreamer.prototype.disconnect = function() {
	// if (this.videoElement) {
	// 	this.videoElement.src = "";
	// }
	if (this.pc) {
		api_fetch(this.srvurl + "/api/hangup?peerid="+this.pc.peerid);
		
		try {
			this.pc.close();
		}
		catch (e) {
			if (debug) console.log ("Failure close peer connection:" + e);
		}
		this.pc = null;
	}
}

/**
 * Keepalive a WebRTC Stream
*/
WebRtcStreamer.prototype.keep_alive = function() {
	// if (this.videoElement) {
	// 	this.videoElement.src = "";
	// }
	if (this.pc) {
		api_fetch(this.srvurl + "/api/keep_alive?peerid="+this.pc.peerid);
	}
}

/*
* GetIceServers callback
*/
WebRtcStreamer.prototype.onReceiveGetIceServers = function(iceServers, videourl, audiourl, options, stream) {
	this.iceServers       = iceServers;
	this.pcConfig         = iceServers || {"iceServers": [] };
	try {
		this.createPeerConnection();

		var callurl = this.srvurl + "/api/call?peerid="+ this.pc.peerid+"&url="+encodeURIComponent(videourl);
		if (audiourl) {
			callurl += "&audiourl="+encodeURIComponent(audiourl);
		}
		if (options) {
			callurl += "&options="+encodeURIComponent(options);
		}

		if (stream) {
			this.pc.addStream(stream);
			// this.pc.addTracktrack, stream);
			this.pc.addTransceiver('video')
			// this.pc.addTransceiver('audio')
		}

                // clear early candidates
		this.earlyCandidates.length = 0;

		// create Offer
		var bind = this;
		this.pc.createOffer(this.mediaConstraints).then(function(sessionDescription) {

			if (debug)  console.log("Create offer (): " + JSON.stringify(sessionDescription));
			
			bind.pc.setLocalDescription(sessionDescription
				, function() {
					if (debug) console.log("setLocalDescription ")
					api_fetch(callurl, {
							method: 'POST',
							headers: {
								'Content-Type' : 'application/json'
							},
							body: JSON.stringify(sessionDescription)
						}, 
					)
					.then(response => {
						if (!response.ok){
							console.error("creating offer, response not ok {response.status} {response.statusText}")
							throw new Error("response not ok {response.status} {response.statusText}" )
						}
						
						return response.json();
						
					})
					.then(data => {
						bind.onReceiveCall.call(bind,data);
					})
					.catch(error => bind.onError("call" + error));

					// request("POST" , callurl, { body: JSON.stringify(sessionDescription) })
					// 	.done( function (response) {
					// 		if (response.statusCode === 200) {
					// 			bind.onReceiveCall.call(bind,JSON.parse(response.body));
					// 		}
					// 		else {
					// 			bind.onError("call " + response.statusCode);
					// 		}
					// 	}
					// );
				}
				, function(error) {
					console.error("setLocalDescription error:" + JSON.stringify(error));
				} );

		}, function(error) {
			alert("Create offer error:" + JSON.stringify(error));
		});

	} catch (e) {
		this.disconnect();
		alert("connect error: " + e);
	}
}


WebRtcStreamer.prototype.getIceCandidate = function() {
	var bind = this;
	api_fetch(this.srvurl + "/api/getIceCandidate?peerid=" + this.pc.peerid)
		.then(response => {
			if (!response.ok){
				throw new Error("response not ok {response.status} {response.statusText}" )
			}
			return response.json();
			
		})
		.then(data => {
			bind.onReceiveCandidate.call(bind, data);
		})
		.catch(error => bind.onError("getIceCandidate" + error));

	// request("GET" , this.srvurl + "/api/getIceCandidate?peerid=" + this.pc.peerid)
	// 	.done( function (response) {
	// 		if (response.statusCode === 200) {
	// 			bind.onReceiveCandidate.call(bind,JSON.parse(response.body));
	// 		}
	// 		else {
	// 			bind.onError("getIceCandidate" + response.statusCode);
	// 		}
	// 	}
	// );
}

/*
* create RTCPeerConnection
*/
WebRtcStreamer.prototype.createPeerConnection = function() {
	if (debug)  console.log("createPeerConnection  config: " + JSON.stringify(this.pcConfig) + " option:"+  JSON.stringify(this.pcOptions));
	this.pc = new RTCPeerConnection(this.pcConfig, this.pcOptions);
	var pc = this.pc;
	pc.peerid = Math.random();

	var bind = this;
	pc.onicecandidate = function(evt) { bind.onIceCandidate.call(bind, evt); };
	// pc.onaddstream    = function(evt) { bind.onAddStream.call(bind,evt); };
	pc.ontrack    = function(evt) { bind.onTrack.call(bind,evt); };
	pc.oniceconnectionstatechange = function(evt) {
		if (debug)  console.log("oniceconnectionstatechange  state: " + pc.iceConnectionState);
		if (this.videoElement) {
			if (pc.iceConnectionState === "connected") {
				this.videoElement.style.opacity = "1.0";
			}
			else if (pc.iceConnectionState === "disconnected") {
				this.videoElement.style.opacity = "0.25";
			}
			else if ( (pc.iceConnectionState === "failed") || (pc.iceConnectionState === "closed") )  {
				this.videoElement.style.opacity = "0.5";
			} else if (pc.iceConnectionState === "new") {
				bind.getIceCandidate.call(bind)
			}
		}
	}
	pc.ondatachannel = function(evt) {
		if (debug) console.log("remote datachannel created:"+JSON.stringify(evt));

		evt.channel.onopen = function () {
			if (debug) console.log("remote datachannel open");
			this.send("remote channel openned");
		}
		evt.channel.onmessage = function (event) {
			if (debug) console.log("remote datachannel recv:"+JSON.stringify(event.data));
		}
	}

	try {
		var dataChannel = pc.createDataChannel("ClientDataChannel");
		dataChannel.onopen = function() {
			if (debug) console.log("local datachannel open");
			this.send("local channel openned");
		}
		dataChannel.onmessage = function(evt) {
			if (debug) console.log("local datachannel recv:"+JSON.stringify(evt.data));
		}
	} catch (e) {
		if (debug) console.log("Cannor create datachannel error: " + e);
	}

	if (debug) console.log("Created RTCPeerConnnection with config: " + JSON.stringify(this.pcConfig) + "option:"+  JSON.stringify(this.pcOptions) );
	return pc;
}


/*
* RTCPeerConnection IceCandidate callback
*/
WebRtcStreamer.prototype.onIceCandidate = function (event) {
	if (event.candidate) {
                if (this.pc.currentRemoteDescription)  {
			this.addIceCandidate(this.pc.peerid, event.candidate);
		} else {
			this.earlyCandidates.push(event.candidate);
		}
	}
	else {
		if (debug) console.log("End of candidates.");
	}
}


WebRtcStreamer.prototype.addIceCandidate = function(peerid, candidate) {
	var bind = this;
	api_fetch(this.srvurl + "/api/addIceCandidate?peerid="+peerid, {
			method: 'POST',
			headers: {
				'Content-Type' : 'application/json'
			},
			body: JSON.stringify(candidate)
		}, 
	)
	.then(response => {
		if (!response.ok){
			throw new Error("response not ok {response.status} {response.statusText}" )
		}
		if (debug) console.log("addIceCandidate ok:" + response.statusText);
		
	})
	.catch(error => bind.onError("addIceCandidate " + error));

	// request("POST" , this.srvurl + "/api/addIceCandidate?peerid="+peerid, { body: JSON.stringify(candidate) })
	// 	.done( function (response) {
	// 		if (response.statusCode === 200) {
	// 			console.log("addIceCandidate ok:" + response.body);
	// 		}
	// 		else {
	// 			bind.onError("addIceCandidate " +response.statusCode);
	// 		}
	// 	}
	// );
}

/*
* RTCPeerConnection AddStream callback
*/
WebRtcStreamer.prototype.onAddStream = function(event) {
	if (debug) console.log("Remote stream added:" +  JSON.stringify(event));

	this.videoElement.srcObject = event.stream;
	var promise = this.videoElement.play();
	if (promise !== undefined) {
	  var bind = this;
	  promise.catch(function(error) {
		console.warn("error:"+error);
		bind.videoElement.setAttribute("controls", true);
	  });
	}
}

/*
* RTCPeerConnection onTrack callback
*/
WebRtcStreamer.prototype.onTrack = function(event) {
	if (debug) console.log("Remote track:" +  JSON.stringify(event));
	this.videoElement.srcObject = event.streams[0];
	var promise = this.videoElement.play();
	if (promise !== undefined) {
	  var bind = this;
	  promise.catch(function(error) {
		console.warn("error:"+error);
		bind.videoElement.setAttribute("controls", true);
	  });
	}
}


/*
* AJAX /call callback
*/
WebRtcStreamer.prototype.onReceiveCall = function(dataJson) {
	var bind = this;
	if (debug) console.log("offer: " + JSON.stringify(dataJson));
	var descr = new RTCSessionDescription(dataJson);
	this.pc.setRemoteDescription(descr
		, function()      {
			if (debug) console.log ("setRemoteDescription ok");
			while (bind.earlyCandidates.length) {
				var candidate = bind.earlyCandidates.shift();
				bind.addIceCandidate.call(bind, bind.pc.peerid, candidate);
			}

			bind.getIceCandidate.call(bind)
		}
		, function(error) {
			if (debug) console.log ("setRemoteDescription error:" + JSON.stringify(error));
		});
}

/*
* AJAX /getIceCandidate callback
*/
WebRtcStreamer.prototype.onReceiveCandidate = function(dataJson) {
	if (debug) console.log("candidate: " + JSON.stringify(dataJson));
	if (dataJson) {
		for (var i=0; i<dataJson.length; i++) {
			var candidate = new RTCIceCandidate(dataJson[i]);

			if (debug) console.log("Adding ICE candidate :" + JSON.stringify(candidate) );
			this.pc.addIceCandidate(candidate
				, function()      { console.log ("addIceCandidate OK"); }
				, function(error) { console.log ("addIceCandidate error:" + JSON.stringify(error)); } );
		}
		// this.pc.addIceCandidate();
	}
}


/*
* AJAX callback for Error
*/
WebRtcStreamer.prototype.onError = function(status) {
	console.error("onError:" + status);
}

return WebRtcStreamer;
})();

// if (typeof module !== 'undefined' && typeof module.exports !== 'undefined')
	// module.exports = WebRtcStreamer;
// else
	// window.WebRtcStreamer = WebRtcStreamer;

export default WebRtcStreamer;
